(function () {
  'use strict';

  var SCROLL_COMPACT_THRESHOLD = 24;

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* ── Scroll reveal ── */
  function initScrollAnimations() {
    var selectors = [
      '.tcc-animate',
      '.tcc-animate-scale',
      '.tcc-animate-left',
      '.tcc-animate-right',
      '.tcc-animate-fade',
    ].join(',');

    var elements = document.querySelectorAll(selectors);
    if (!elements.length) return;

    if (prefersReducedMotion()) {
      elements.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -32px 0px' }
    );

    elements.forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ── Stagger product & collection cards ── */
  function initStaggerReveal() {
    if (prefersReducedMotion()) return;

    var grids = document.querySelectorAll(
      '.resource-list__item, product-card, .tcc-collections__card, .tcc-trust__card'
    );

    grids.forEach(function (el, index) {
      el.classList.add('tcc-stagger-item');
      el.style.setProperty('--tcc-stagger-index', String(index % 8));
    });

    var staggerObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('tcc-stagger-item--visible');
            staggerObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.05, rootMargin: '0px 0px -20px 0px' }
    );

    document.querySelectorAll('.tcc-stagger-item').forEach(function (el) {
      staggerObserver.observe(el);
    });
  }

  /* ── Hero entrance on load ── */
  function initHeroEntrance() {
    if (prefersReducedMotion()) return;

    var hero = document.querySelector('.tcc-hero');
    if (!hero) return;

    requestAnimationFrame(function () {
      hero.classList.add('tcc-hero--loaded');
    });
  }

  /* ── Subtle hero parallax ── */
  function initHeroParallax() {
    if (prefersReducedMotion()) return;
    if (window.matchMedia('(max-width: 749px)').matches) return;

    var hero = document.querySelector('.tcc-hero');
    var bg = hero && hero.querySelector('.tcc-hero__bg--mobile, .tcc-hero__bg');
    if (!hero || !bg) return;

    var ticking = false;

    function updateParallax() {
      ticking = false;
      var rect = hero.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > window.innerHeight) return;

      var progress = -rect.top / (rect.height + window.innerHeight);
      var offset = progress * 60;
      bg.style.transform = 'scale(1.08) translateY(' + offset + 'px)';
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(updateParallax);
      }
    }

    var scrollTarget = document.querySelector('.page-wrapper') || window;
    scrollTarget.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('scroll', onScroll, { passive: true });
    updateParallax();
  }

  /* ── Compact header on scroll ── */
  function initHeaderShrink() {
    var headerComponent = document.querySelector('#header-component');
    var headerGroup = document.querySelector('#header-group');
    var header = headerComponent && headerComponent.querySelector('.header');
    if (!headerComponent || !header) return;

    var ticking = false;

    function getScrollTop() {
      var wrapper = document.querySelector('.page-wrapper');
      if (wrapper && wrapper.scrollTop > 0) return wrapper.scrollTop;
      return window.scrollY || document.documentElement.scrollTop || 0;
    }

    function updateHeaderState() {
      ticking = false;
      var scrolled = getScrollTop() > SCROLL_COMPACT_THRESHOLD;

      headerComponent.classList.toggle('tcc-header--compact', scrolled);
      header.classList.toggle('header--compact', scrolled);
      header.classList.toggle('tcc-header--expanded', !scrolled);

      if (headerGroup) headerGroup.classList.toggle('tcc-header-group--compact', scrolled);
      document.body.classList.toggle('tcc-scrolled', scrolled);
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(updateHeaderState);
      }
    }

    var scrollTarget = document.querySelector('.page-wrapper') || window;
    scrollTarget.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('scroll', onScroll, { passive: true });
    updateHeaderState();
  }

  /* ── Gold shimmer on primary buttons ── */
  function initButtonShimmer() {
    if (prefersReducedMotion()) return;

    document.querySelectorAll('.tcc-btn--primary, .button:not(.button-unstyled):not(.link)').forEach(function (btn) {
      if (btn.closest('.tcc-newsletter')) return;
      btn.classList.add('tcc-btn-shimmer');
    });
  }

  /* ── Mobile drawer: restore Shop accordion after close/reopen ── */
  function initDrawerShopAccordion() {
    var drawerDetails = document.querySelector('#Details-menu-drawer-container');
    if (!drawerDetails || drawerDetails.dataset.tccShopAccordionInit) return;

    drawerDetails.dataset.tccShopAccordionInit = 'true';

    function restoreShopAccordion() {
      if (!drawerDetails.hasAttribute('open')) return;

      requestAnimationFrame(function () {
        var shopAccordion = drawerDetails.querySelector('.tcc-drawer__item--shop .tcc-drawer__accordion');
        if (shopAccordion) {
          shopAccordion.setAttribute('open', '');
        }
      });
    }

    drawerDetails.addEventListener('toggle', restoreShopAccordion);
  }

  function initAll() {
    initScrollAnimations();
    initStaggerReveal();
    initHeroEntrance();
    initHeroParallax();
    initHeaderShrink();
    initButtonShimmer();
    initDrawerShopAccordion();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
